import { Container } from "@mui/material";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { ReactNode, useContext, useEffect } from "react";
import BreadcrumbsWrapper from "../Common/BreadcrumbsWrapper";
import { TripContext } from "../ContextProviders/BookingContextProvider";
import Page from "../Page";
import TripBody from "./TripBody";
import TripHeader from "./TripHeader";
import { TripInformation } from "./TripInformation";

type MoreInformationProps = {
  tripInformation: TripInformation;
  timeTable: ReactNode;
  title: string;
  description: string;
};

const MoreInformation = ({ tripInformation, timeTable, title, description }: MoreInformationProps) => {
  const { t } = useTranslation();

  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Trips", link: "/#trips" },
    { label: t(tripInformation.title), isActive: true },
  ];

  const { selectTrip, selectedTrip } = useContext(TripContext);

  useEffect(() => {
    if (!selectedTrip || selectedTrip.id !== tripInformation.tripObjectId) {
      selectTrip(tripInformation.tripObjectId);
    }
  }, [selectedTrip, selectTrip, tripInformation]);

  return (
    <Page isFrontPage={false} title={title} description={description}>
      <Container>
        <section className="section" id="more-information">
          <BreadcrumbsWrapper items={breadcrumbs} />
          <TripHeader tripInformation={tripInformation} />
          <TripBody tripInformation={tripInformation} timeTable={timeTable} />
        </section>
      </Container>
    </Page>
  );
};

export default MoreInformation;
